// api.js
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

export const revisePyq = async (topic,message_id) => {
  const accessToken = localStorage.getItem("access_token");
  if (!accessToken) return Promise.reject("Unauthorized");
  try {
    const response = await axios.post(
      `${BASE_URL}llms/pyq-revise`,
      {
        topic: topic,
        message_id:message_id
      },
      {
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`, // remove if not required
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};
